import { AMLS_COMMON } from '../../../../pages/constants/globalConstants';
import { createAxiosServiceInstance } from '../../../api';

const BASE = `${AMLS_COMMON}/fraudactions`;

// Note: createAxiosServiceInstance() configures axios with `validateStatus: false`,
// so 4xx/5xx responses do NOT throw natively — the manual `if (status >= 400)`
// blocks below are required to surface errors to sagas.
class ActionCatalogModule {
  constructor() {
    this.axios = createAxiosServiceInstance();
  }

  list = async () => {
    const response = await this.axios.get(BASE);
    if (response && response.status && response.status >= 400) {
      throw new Error(
        response?.data?.message || 'Failed to load action catalog'
      );
    }
    const payload = response?.data ?? response;
    return Array.isArray(payload) ? payload : [];
  };

  create = async (payload) => {
    const response = await this.axios.post(BASE, payload);
    if (response && response.status && response.status >= 400) {
      const err = new Error(response?.data?.message || 'Failed to create');
      err.response = response;
      throw err;
    }
    return response?.data;
  };

  update = async (originalName, payload) => {
    const response = await this.axios.put(
      `${BASE}/${encodeURIComponent(originalName)}`,
      payload
    );
    if (response && response.status && response.status >= 400) {
      const err = new Error(response?.data?.message || 'Failed to update');
      err.response = response;
      throw err;
    }
    return response?.data;
  };

  remove = async (name) => {
    const response = await this.axios.delete(
      `${BASE}/${encodeURIComponent(name)}`
    );
    if (response && response.status && response.status >= 400) {
      const err = new Error(response?.data?.message || 'Failed to delete');
      err.response = response;
      throw err;
    }
    return response?.data;
  };

  reorder = async (entries) => {
    const response = await this.axios.patch(`${BASE}/reorder`, entries);
    if (response && response.status && response.status >= 400) {
      const err = new Error(response?.data?.message || 'Failed to reorder');
      err.response = response;
      throw err;
    }
    return response?.data;
  };
}

export default ActionCatalogModule;
